/*
	Settings page for user preferences and account management
	Includes sections for profile, security, and notifications
	Uses accordion component for collapsible sections
*/

import React from 'react';
import { Outlet } from 'react-router-dom';

// Settings page component
const SettingsPage: React.FC = () => {
	return (
		<div className="p-6">
			<Outlet />
		</div>
	);
};

// Export the component
export default SettingsPage;
